import { render } from "./AppInstall.vue?vue&type=template&id=080ca496"
import script from "./AppInstall.vue?vue&type=script&lang=js"
export * from "./AppInstall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__